import { render, staticRenderFns } from "./orderNxshenpi1+N.vue?vue&type=template&id=0d8df676&scoped=true"
import script from "./orderNxshenpi1+N.vue?vue&type=script&lang=js"
export * from "./orderNxshenpi1+N.vue?vue&type=script&lang=js"
import style0 from "./orderNxshenpi1+N.vue?vue&type=style&index=0&id=0d8df676&prod&scoped=true&lang=css"
import style1 from "./orderNxshenpi1+N.vue?vue&type=style&index=1&id=0d8df676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8df676",
  null
  
)

export default component.exports